import ImageModalDsk from 'components/common/ImageModalDsk'
import ImageModalMbl from 'components/common/ImageModalMbl'
import NextButton from 'components/common/NextButton'
import PrevButton from 'components/common/PrevButton'
import { BLUR_DATA_URL, MEDIA_URL } from 'config/constants'
import { useKeenSlider } from 'keen-slider/react'
import { isSame } from 'lib/utils'
import Image from 'next/image'
import { useCallback, useState } from 'react'
import { useSelector } from 'react-redux'
import { IGetAboutResult } from 'store/api'
import { selectIsMd } from 'store/ui'

type Props = {
  thanksSSR: IGetAboutResult[]
}

const GratitudeSlider = ({ thanksSSR }: Props) => {
  let [isMblModalOpen, setIsMblModalOpen] = useState(false)
  let [isDskModalOpen, setIsDskModalOpen] = useState(false)

  let [imgIdx, setImgIdx] = useState<number | null>(null)
  let handleModalOpen = useCallback(
    (idx: number, type: 'dsk' | 'mbl') => {
      setImgIdx(idx)
      isSame(type, 'mbl')
        ? setIsMblModalOpen(true)
        : setIsDskModalOpen(true)
    },
    []
  )
  const [currentSlide, setCurrentSlide] = useState(0)
  const [maxIndex, setMaxIndex] = useState(0)

  let [ref, slider] = useKeenSlider<HTMLDivElement>({
    slides: {
      perView: 5.2,
      spacing: 16,
    },
    breakpoints: {
      '(min-width: 1280px)': {
        slides: {
          perView: 6.5,
          spacing: 32,
        },
      },
    },
    created(slider) {
      setMaxIndex(slider.track.details.maxIdx)
    },
    slideChanged(slider) {
      setCurrentSlide(slider.track.details.rel)
      setMaxIndex(slider.track.details.maxIdx)
    },
  })

  let isMd = useSelector(selectIsMd)

  let images = thanksSSR?.map((t) => ({
    src: `${MEDIA_URL}${t.image}`,
    height: 1,
    width: 1,
    blurDataURL: '',
  }))

  return (
    <div className='bg-transparent lg:mt-2 mb-10 pt-12'>
      <div className='flex items-center justify-between z-10 mb-6 lg:mb-2'>
        <div className='text-base font-bold uppercase font-unbounded leading-tight'>
          Сертификаты:
        </div>

        <div className='hidden md:flex gap-4 justify-end flex-1 pr-4 xl:pr-12'>
          <PrevButton
            active={currentSlide > 0}
            onClick={() => slider.current?.prev()}
          />
          <NextButton
            active={currentSlide < maxIndex}
            onClick={() => slider.current?.next()}
          />
        </div>
      </div>

      {isMd && (
        <div className='keen-slider z-10' ref={ref}>
          {thanksSSR.length > 0 &&
            thanksSSR.map((t, idx) => (
              <div
                key={t.id}
                className='keen-slider__slide py-4 px-2'
              >
                <div className='relative aspect-w-10 aspect-h-14 cursor-zoom-in rounded-xl overflow-hidden shadow-dark'>
                  <Image
                    onClick={() => handleModalOpen(idx, 'dsk')}
                    placeholder='blur'
                    blurDataURL={BLUR_DATA_URL}
                    src={`${MEDIA_URL}${t.image}`}
                    alt=''
                    layout='fill'
                    objectFit='cover'
                  />
                </div>
              </div>
            ))}
        </div>
      )}

      {!isMd && (
        <div className='flex flex-nowrap overflow-x-auto omit-scrollbar thin-scrollbar'>
          {thanksSSR.length > 0 &&
            thanksSSR.map((t, idx) => (
              <div
                key={t.id}
                className='w-[40%] flex-shrink-0 py-4 px-2'
              >
                <div className='aspect-w-10 aspect-h-14 relative  rounded-lg overflow-hidden shadow-dark'>
                  <Image
                    onClick={() => handleModalOpen(idx, 'mbl')}
                    placeholder='blur'
                    blurDataURL={BLUR_DATA_URL}
                    src={`${MEDIA_URL}${t.image}`}
                    alt=''
                    layout='fill'
                    objectFit='cover'
                  />
                </div>
              </div>
            ))}
        </div>
      )}

      <ImageModalDsk
        images={images}
        idx={imgIdx ?? 0}
        src={`${MEDIA_URL}${thanksSSR[imgIdx ?? 0]!.image}`}
        isOpen={isDskModalOpen}
        setIsOpen={setIsDskModalOpen}
      />

      <ImageModalMbl
        images={images}
        src={`${MEDIA_URL}${thanksSSR[imgIdx ?? 0]!.image}`}
        idx={imgIdx ?? 0}
        isOpen={isMblModalOpen}
        setIsOpen={setIsMblModalOpen}
      />
    </div>
  )
}

export default GratitudeSlider
